import { useState, useEffect, useRef } from "react";
import { useApp, EMOJI_CATS, api, setToken } from "./context";

export const GlobalStyle = () => (
  <>
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    <style>{`
      html, body, #root { cursor: default !important; margin: 0; padding: 0; overflow-x: hidden; width: 100%; }
      html { height: 100%; overflow: hidden; }
      body { height: 100%; overflow-y: auto; -webkit-overflow-scrolling: touch; }
      *, *::before, *::after { cursor: inherit !important; box-sizing: border-box; }
      input[type="text"], input[type="email"], input[type="password"], input[type="search"], input[type="url"], input[type="tel"], input[type="number"], textarea, [contenteditable="true"] { cursor: text !important; -webkit-user-select: text; user-select: text; font-size: 16px !important; }
      ::-webkit-scrollbar { width: 0; height: 0; }
      @keyframes topbarSlideDown { from { transform: translateY(-100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
      @keyframes composerSlideUp { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
    `}</style>
  </>
);

export const FormInput = ({ label, type = "text", placeholder, value, onChange, onKeyDown, autoComplete }) => {
  const { c } = useApp();
  return (
    <div style={{ marginBottom: 14, textAlign: "left" }}>
      <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: c.sub, marginBottom: 5, letterSpacing: "0.06em" }}>{label}</label>
      <input style={{ width: "100%", padding: "12px 15px", borderRadius: 11, border: `1.5px solid ${c.border}`, background: c.input, color: c.text, fontSize: 14, outline: "none", boxSizing: "border-box", fontFamily: "inherit" }} type={type} placeholder={placeholder} value={value} onChange={onChange} onKeyDown={onKeyDown} autoComplete={autoComplete || "off"} />
    </div>
  );
};

export const Toast = () => {
  const { c, toast } = useApp();
  if (!toast) return null;
  return <div style={{ position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)", padding: "12px 24px", borderRadius: 14, fontSize: 14, fontWeight: 600, zIndex: 9999, background: toast.type === "success" ? (c.bg === "#0b0c10" ? "#065f46" : "#d1fae5") : (c.bg === "#0b0c10" ? "#7f1d1d" : "#fee2e2"), color: toast.type === "success" ? c.grnTxt : c.redTxt, boxShadow: c.shd, border: `1px solid ${toast.type === "success" ? c.grn : c.red}25`, backdropFilter: "blur(8px)" }}>{toast.msg}</div>;
};

export const VerifiedBadge = ({ size = 15 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={size} height={size} style={{ display: "inline-block", verticalAlign: "middle", marginLeft: 4, flexShrink: 0 }}>
    <defs><linearGradient id="vblu" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#3BB3FF"/><stop offset="100%" stopColor="#0A66D1"/></linearGradient></defs>
    <path fill="url(#vblu)" d="M50 5 L60 12 L72 10 L80 20 L92 28 L90 40 L98 50 L90 60 L92 72 L80 80 L72 90 L60 88 L50 95 L40 88 L28 90 L20 80 L8 72 L10 60 L2 50 L10 40 L8 28 L20 20 L28 10 L40 12 Z"/>
    <path d="M32 52 L45 65 L72 35" fill="none" stroke="#fff" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PremiumBadge = ({ size = 15 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={size} height={size} style={{ display: "inline-block", verticalAlign: "middle", marginLeft: 4, flexShrink: 0 }}>
    <defs><linearGradient id="vpur" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#C084FC"/><stop offset="100%" stopColor="#6D28D9"/></linearGradient></defs>
    <circle cx="50" cy="50" r="45" fill="url(#vpur)"/>
    <text x="50" y="57" textAnchor="middle" fontFamily="Arial,Helvetica,sans-serif" fontSize="18" fontWeight="bold" fill="#fff">PRO</text>
  </svg>
);

export const PremiumVerifiedBadge = ({ size = 15 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={size} height={size} style={{ display: "inline-block", verticalAlign: "middle", marginLeft: 4, flexShrink: 0 }}>
    <defs><linearGradient id="vpurv" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#C084FC"/><stop offset="100%" stopColor="#6D28D9"/></linearGradient></defs>
    <path fill="url(#vpurv)" d="M50 2 L58 12 L72 6 L78 20 L94 26 L88 40 L100 50 L88 60 L94 74 L78 80 L72 94 L58 88 L50 98 L42 88 L28 94 L22 80 L6 74 L12 60 L0 50 L12 40 L6 26 L22 20 L28 6 L42 12 Z"/>
    <path d="M30 52 L45 67 L75 33" fill="none" stroke="#fff" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const EliteBadge = ({ size = 15 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={size} height={size} style={{ display: "inline-block", verticalAlign: "middle", marginLeft: 4, flexShrink: 0 }}>
    <defs><linearGradient id="vgld" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#FFF2A8"/><stop offset="50%" stopColor="#F5C518"/><stop offset="100%" stopColor="#B8860B"/></linearGradient></defs>
    <circle cx="50" cy="50" r="45" fill="url(#vgld)"/>
    <text x="50" y="57" textAnchor="middle" fontFamily="Arial,Helvetica,sans-serif" fontSize="18" fontWeight="bold" fill="#fff">VIP</text>
  </svg>
);

export const EliteVerifiedBadge = ({ size = 15 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={size} height={size} style={{ display: "inline-block", verticalAlign: "middle", marginLeft: 4, flexShrink: 0 }}>
    <defs><linearGradient id="vgldv" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#FFF2A8"/><stop offset="50%" stopColor="#F5C518"/><stop offset="100%" stopColor="#B8860B"/></linearGradient></defs>
    <path fill="url(#vgldv)" d="M50 1 L60 14 L75 5 L82 22 L98 30 L90 45 L100 50 L90 55 L98 70 L82 78 L75 95 L60 86 L50 99 L40 86 L25 95 L18 78 L2 70 L10 55 L0 50 L10 45 L2 30 L18 22 L25 5 L40 14 Z"/>
    <circle cx="50" cy="50" r="30" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="3"/>
    <path d="M28 52 L45 70 L78 30" fill="none" stroke="#fff" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TierBadge = ({ plan, verified, size = 15 }) => {
  if (plan === "elite" && verified) return <EliteVerifiedBadge size={size} />;
  if (plan === "elite") return <EliteBadge size={size} />;
  if (plan === "premium" && verified) return <PremiumVerifiedBadge size={size} />;
  if (plan === "premium") return <PremiumBadge size={size} />;
  if (verified) return <VerifiedBadge size={size} />;
  return null;
};

export const Avatar = ({ id, size = 42, onClick, style: sx, pic: picProp }) => {
  const { getAuthorPic, getAuthorEmoji, getAuthorColor } = useApp();
  const pic = picProp || getAuthorPic(id);
  const em = getAuthorEmoji(id);
  const col = getAuthorColor(id);

  if (pic) {
    return (
      <div onClick={onClick} style={{ width: size, height: size, borderRadius: size * 0.3, flexShrink: 0, cursor: onClick ? "pointer" : "default", overflow: "hidden", ...sx }}>
        <img src={pic} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} onError={e => { e.target.style.display = "none"; }} />
      </div>
    );
  }
  return (
    <div onClick={onClick} style={{ width: size, height: size, borderRadius: size * 0.3, flexShrink: 0, cursor: onClick ? "pointer" : "default", background: `${col}20`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.45, color: col, fontWeight: 700, overflow: "hidden", ...sx }}>
      {em}
    </div>
  );
};

export const TopBar = ({ title, showBack, right, onBack }) => {
  const { c, dark, go, user, unreadNotifs, setShowSidebar, showSidebar, back: goBack } = useApp();
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    // Only hide topbar on feed page (no showBack)
    if (showBack) return;
    const body = document.body;
    const handleScroll = () => {
      const currentY = body.scrollTop;
      if (currentY < 60) { setVisible(true); return; }
      if (currentY < lastScrollY.current) {
        // Scrolling up — show topbar
        setVisible(true);
      } else if (currentY > lastScrollY.current + 5) {
        // Scrolling down — hide topbar
        setVisible(false);
      }
      lastScrollY.current = currentY;
    };
    body.addEventListener("scroll", handleScroll, { passive: true });
    return () => body.removeEventListener("scroll", handleScroll);
  }, [showBack]);

  return (
    <header style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
      background: dark ? "#0b0c10ee" : "#ffffffee",
      backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)",
      borderBottom: `1px solid ${c.border}`,
      transform: visible ? "translateY(0)" : "translateY(-100%)",
      transition: "transform 0.25s ease",
    }}>
      <div style={{ maxWidth: 680, margin: "0 auto", padding: "10px 16px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        {showBack ? (
          <button onClick={onBack || goBack} style={{ width: 36, height: 36, borderRadius: 10, border: `1px solid ${c.border}`, background: c.card, color: c.sub, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 16, flexShrink: 0 }}>←</button>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: c.grad, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 }}>
              <svg width="28" height="28" viewBox="0 0 100 100"><line x1="50" y1="50" x2="22" y2="22" stroke="rgba(255,255,255,0.4)" strokeWidth="3"/><line x1="50" y1="50" x2="78" y2="22" stroke="rgba(255,255,255,0.4)" strokeWidth="3"/><line x1="50" y1="50" x2="22" y2="78" stroke="rgba(255,255,255,0.4)" strokeWidth="3"/><line x1="50" y1="50" x2="78" y2="78" stroke="rgba(255,255,255,0.4)" strokeWidth="3"/><circle cx="22" cy="22" r="8" fill="rgba(255,255,255,0.6)"/><circle cx="78" cy="22" r="8" fill="rgba(255,255,255,0.6)"/><circle cx="22" cy="78" r="8" fill="rgba(255,255,255,0.6)"/><circle cx="78" cy="78" r="8" fill="rgba(255,255,255,0.6)"/><text x="50" y="62" fontSize="38" fill="white" fontFamily="Arial" fontWeight="800" textAnchor="middle">G</text></svg>
            </div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 800, color: c.text, lineHeight: 1.1 }}>Geilstore Community</div>
              {user?.location && <div style={{ fontSize: 10, color: c.faint, display: "flex", alignItems: "center", gap: 3 }}>
                <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#e91e8c" strokeWidth="3"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>
                {user.location}
              </div>}
            </div>
          </div>
        )}
        {showBack && <span style={{ fontSize: 16, fontWeight: 700, color: c.text }}>{title}</span>}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {right}
          {!showBack && (
            <button onClick={() => go("notifications")} style={{ width: 34, height: 34, borderRadius: 9, border: `1px solid ${c.border}`, background: c.card, color: c.sub, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", position: "relative" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
              {unreadNotifs > 0 && <span style={{ position: "absolute", top: -3, right: -3, minWidth: 16, height: 16, borderRadius: 8, background: "#e91e8c", color: "#fff", fontSize: 9, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 3px" }}>{unreadNotifs}</span>}
            </button>
          )}
          <button onClick={() => setShowSidebar(!showSidebar)} style={{ width: 34, height: 34, borderRadius: 9, border: `1px solid ${c.border}`, background: c.card, color: c.sub, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export const BottomNav = () => {
  const { c, dark, page, go, setShowSidebar, setShowComposer } = useApp();
  const navItems = [
    { id: "feed", label: "Home", icon: (active) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill={active ? c.pri : "none"} stroke={active ? c.pri : c.faint} strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22" fill={active ? "#fff" : "none"} stroke={active ? c.pri : c.faint}/></svg>
    )},
    { id: "meetups", label: "Requests", icon: (active) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill={active ? "#e91e8c" : "none"} stroke={active ? "#e91e8c" : c.faint} strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
    )},
    { id: "post_btn", label: "Post", icon: () => null },
    { id: "leaderboard", label: "Jilink AI", icon: (active) => (
      <div style={{ width: 22, height: 22, borderRadius: "50%", background: active ? "linear-gradient(135deg,#6c5ce7,#e91e8c)" : "transparent", border: active ? "none" : "2px solid " + c.faint, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, color: active ? "#fff" : c.faint, fontWeight: 800 }}>✦</div>
    )},
    { id: "messages", label: "Messages", icon: (active) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill={active ? "#3b82f6" : "none"} stroke={active ? "#3b82f6" : c.faint} strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
    )},
  ];
  return (
    <nav style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 100, background: dark ? "#12131aee" : "#ffffffee", backdropFilter: "blur(20px)", borderTop: `1px solid ${c.border}`, padding: "4px 0 8px" }}>
      <div style={{ maxWidth: 680, margin: "0 auto", display: "flex", justifyContent: "space-around", alignItems: "flex-end" }}>
        {navItems.map(item => {
          const active = page === item.id;
          if (item.id === "post_btn") return (
            <div key="post_btn" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, marginBottom: 4 }}>
              <button
                onClick={() => {
                  setShowSidebar(false);
                  // Navigate to feed first if not already there
                  if (page !== "feed") go("feed");
                  // Small delay to ensure feed is rendered before opening composer
                  setTimeout(() => {
                    if (setShowComposer) setShowComposer(true);
                  }, page !== "feed" ? 100 : 0);
                }}
                style={{ width: 50, height: 50, borderRadius: 25, background: "linear-gradient(135deg, #6c5ce7, #e91e8c)", border: "3px solid " + (dark ? "#12131a" : "#fff"), display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", marginTop: -18, boxShadow: "0 4px 14px rgba(108,92,231,0.4)" }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              </button>
              <span style={{ fontSize: 10, color: c.faint, fontWeight: 600 }}>Post</span>
            </div>
          );
          return (
            <button key={item.id} onClick={() => { setShowSidebar(false); go(item.id); }} style={{ background: "none", border: "none", display: "flex", flexDirection: "column", alignItems: "center", gap: 2, padding: "6px 10px", cursor: "pointer" }}>
              {item.icon(active)}
              <span style={{ fontSize: 10, fontWeight: 600, color: active ? c.pri : c.faint }}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export const ProfileSidebar = () => {
  const { c, dark, go, user, setUser, showSidebar, setShowSidebar, flash } = useApp();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  useEffect(() => {
    if (showSidebar && user) {
      api("/auth/me").then(r => {
        if (r.ok && r.data) {
          const u = r.data.user || r.data;
          setUser(prev => ({ ...prev, plan: u.plan || prev.plan, verified: u.is_verified ?? prev.verified }));
        }
      });
    }
  }, [showSidebar]); // eslint-disable-line
  if (!showSidebar || !user) return null;
  const plan = user.plan || "free";
  const planColor = plan === "elite" ? "#f59e0b" : plan === "premium" ? "#7c6cff" : c.sub;
  const planLabel = plan === "elite" ? "Elite" : plan === "premium" ? "Premium" : "Basic";
  const nav = (p) => { setShowSidebar(false); go(p); };
  const navSettings = (tab) => { setShowSidebar(false); const map = { account: "edit_profile", privacy: "settings_privacy", notifs: "settings_notifs", appearance: "settings_appearance", security: "settings_security", blocked: "settings_blocked", data: "settings_data" }; go(map[tab] || "settings"); };
  const sections = [
    { title: "MY ACCOUNT", items: [
      { icon: "👤", label: "My Profile", desc: "View your profile & posts", action: () => nav("my_profile") },
      { icon: "✏️", label: "Edit Profile", desc: "Name, bio, photo", action: () => navSettings("account") },
      { icon: "🔖", label: "Bookmarks", desc: "Saved posts", action: () => nav("bookmarks") },
      { icon: "🏅", label: "Badges", desc: "Your achievements", action: () => nav("badges") },
      { icon: "ℹ️", label: "About Me", desc: "Your account details", action: () => nav("about_me") },
    ]},
    { title: "FEATURES", items: [
      { icon: "🤖", label: "AI Matching", desc: "Find compatible members", action: () => nav("leaderboard"), color: "#f59e0b" },
      { icon: "🎬", label: "Movies", desc: "Stream exclusive content", action: () => nav("movies"), color: "#ef4444" },
      { icon: "💕", label: "Meetup Requests", desc: "Connect in person", action: () => nav("meetups"), color: "#ec4899" },
      { icon: "🎟️", label: "Events", desc: "Tickets & happenings", action: () => nav("events"), color: "#10b981" },
      { icon: "🪙", label: "Gtks Wallet", desc: "Buy, send & redeem tokens", action: () => nav("wallet"), color: "#a855f7" },
      { icon: "✉️", label: "Messages", desc: "Your conversations", action: () => nav("messages"), color: "#3b82f6" },
      { icon: "🔴", label: "Red Room", desc: "Anonymous group rooms", action: () => nav("red_room"), color: "#ef4444" },
    ]},
    { title: "MEMBERSHIP", items: [
      { icon: plan === "elite" ? "👑" : plan === "premium" ? "💎" : "⭐", label: `${planLabel} Plan`, desc: plan === "free" ? "Upgrade for more features" : "Manage your subscription", action: () => nav("premium"), color: planColor },
      { icon: "🛡️", label: user.verified ? "Verified ✓" : "Get Verified", desc: user.verified ? "Your account is verified" : "Get the blue tick badge", action: () => navSettings("security"), color: user.verified ? "#10b981" : "#3b82f6" },
    ]},
    { title: "SETTINGS", items: [
      { icon: "🔒", label: "Privacy", desc: "DMs, visibility, online status", action: () => navSettings("privacy") },
      { icon: "🔔", label: "Notifications", desc: "Push, email, alerts", action: () => navSettings("notifs") },
      { icon: "🎨", label: "Appearance", desc: "Dark or light theme", action: () => navSettings("appearance") },
      { icon: "🚫", label: "Blocked Users", desc: "Manage blocked accounts", action: () => navSettings("blocked") },
      { icon: "📊", label: "Data & Privacy", desc: "Export, delete, policies", action: () => navSettings("data") },
    ]},
  ];
  return (
    <>
      <div onClick={() => setShowSidebar(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", zIndex: 998 }} />
      <div style={{ position: "fixed", top: 0, right: 0, bottom: 0, width: "min(320px, 85vw)", background: c.card, zIndex: 999, borderLeft: `1px solid ${c.border}`, display: "flex", flexDirection: "column", animation: "slideInRight 0.25s ease-out", overflowY: "auto" }}>
        <style>{`@keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }`}</style>
        <div style={{ background: `linear-gradient(135deg, #6c5ce7, ${planColor})`, padding: "50px 20px 20px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 56, height: 56, borderRadius: 18, background: user.avatarUrl ? "transparent" : c.grad, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, overflow: "hidden", border: "2px solid rgba(255,255,255,0.3)", flexShrink: 0 }}>{user.avatarUrl ? <img src={user.avatarUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} onError={e => { e.target.style.display = "none"; }} /> : (user.emoji || "👤")}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 17, fontWeight: 800, color: "#fff" }}>{user.name}</div>
              <div style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
                <span style={{ padding: "2px 8px", borderRadius: 6, background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 10, fontWeight: 700 }}>{planLabel}</span>
                {user.verified && <span style={{ padding: "2px 8px", borderRadius: 6, background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 10, fontWeight: 700 }}>Verified ✓</span>}
                <span style={{ padding: "2px 8px", borderRadius: 6, background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 10, fontWeight: 700 }}>★{user.trustScore}</span>
              </div>
            </div>
            <button onClick={() => setShowSidebar(false)} style={{ width: 32, height: 32, borderRadius: 10, background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
          </div>
        </div>
        <div style={{ flex: 1, padding: "8px 12px 100px" }}>
          {sections.map((sec, si) => (
            <div key={si} style={{ marginBottom: 4 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: c.faint, letterSpacing: "0.08em", padding: "12px 8px 6px" }}>{sec.title}</div>
              {sec.items.map((item, ii) => (
                <button key={ii} onClick={item.action} style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", padding: "11px 10px", borderRadius: 12, border: "none", background: "transparent", cursor: "pointer", textAlign: "left" }}>
                  <div style={{ width: 36, height: 36, borderRadius: 10, background: `${item.color || c.pri}10`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 17, flexShrink: 0 }}>{item.icon}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: item.color || c.text }}>{item.label}</div>
                    {item.desc && <div style={{ fontSize: 10, color: c.faint, marginTop: 1 }}>{item.desc}</div>}
                  </div>
                  <span style={{ fontSize: 14, color: c.faint }}>›</span>
                </button>
              ))}
            </div>
          ))}
          <div style={{ padding: "12px 0", borderTop: `1px solid ${c.border}`, marginTop: 8 }}>
            <button onClick={() => setShowLogoutConfirm(true)} style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", padding: "12px 10px", borderRadius: 12, border: "none", background: "transparent", cursor: "pointer", textAlign: "left" }}>
              <span style={{ fontSize: 18, width: 24, textAlign: "center" }}>🚪</span>
              <span style={{ fontSize: 14, fontWeight: 600, color: "#ef4444" }}>Log Out</span>
            </button>
          </div>
          {showLogoutConfirm && (
            <div onClick={() => setShowLogoutConfirm(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(6px)", zIndex: 1000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
              <div onClick={e => e.stopPropagation()} style={{ background: dark ? "#1a1b2e" : "#fff", borderRadius: "20px 20px 0 0", padding: "24px 20px 40px", width: "100%", maxWidth: 480 }}>
                <div style={{ width: 40, height: 4, borderRadius: 2, background: c.border, margin: "0 auto 20px" }} />
                <div style={{ textAlign: "center", marginBottom: 24 }}>
                  <div style={{ fontSize: 40, marginBottom: 12 }}>🚪</div>
                  <div style={{ fontSize: 18, fontWeight: 800, color: c.text, marginBottom: 8 }}>Log Out?</div>
                  <div style={{ fontSize: 13, color: c.sub }}>Are you sure you want to log out of Geilstore Community?</div>
                </div>
                <button onClick={async () => { setShowLogoutConfirm(false); setShowSidebar(false); await api("/auth/logout", { method: "POST" }); setToken(null); setUser(null); sessionStorage.clear(); go("login"); flash("Logged out"); }} style={{ width: "100%", padding: "13px", borderRadius: 12, border: "none", background: "#ef4444", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", marginBottom: 10 }}>Yes, Log Out</button>
                <button onClick={() => setShowLogoutConfirm(false)} style={{ width: "100%", padding: "13px", borderRadius: 12, border: `1px solid ${c.border}`, background: "transparent", color: c.sub, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>Stay — Changed my mind 😊</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export const Shell = ({ title, showBack, right, onBack, children, noNav, noPad }) => {
  const { c } = useApp();
  return (
    <div style={{ minHeight: "100vh", background: c.bg, color: c.text, fontFamily: "'DM Sans',sans-serif", paddingTop: 60, paddingBottom: noNav ? 0 : 76 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <GlobalStyle />
      <Toast />
      <TopBar title={title} showBack={showBack} right={right} onBack={onBack} />
      <div style={{ maxWidth: 680, margin: "0 auto", padding: noPad ? "0" : "0 16px" }}>{children}</div>
      {!noNav && <BottomNav />}<ProfileSidebar />
    </div>
  );
};

export const AuthShell = ({ children }) => {
  const { c, dark } = useApp();
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, background: dark ? "linear-gradient(160deg,#0b0c10 0%,#1a1040 50%,#0b0c10 100%)" : "linear-gradient(160deg,#f4f5f9 0%,#e8e0f0 50%,#f4f5f9 100%)", fontFamily: "'DM Sans',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <GlobalStyle />
      <Toast />
      <div style={{ width: "100%", maxWidth: 400, background: c.card, borderRadius: 24, padding: "40px 28px", boxShadow: c.shd, border: `1px solid ${c.border}` }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 60, height: 60, borderRadius: 17, background: c.grad, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 14, overflow: "hidden" }}><svg width="44" height="44" viewBox="0 0 100 100"><line x1="50" y1="50" x2="22" y2="22" stroke="rgba(255,255,255,0.4)" strokeWidth="3"/><line x1="50" y1="50" x2="78" y2="22" stroke="rgba(255,255,255,0.4)" strokeWidth="3"/><line x1="50" y1="50" x2="22" y2="78" stroke="rgba(255,255,255,0.4)" strokeWidth="3"/><line x1="50" y1="50" x2="78" y2="78" stroke="rgba(255,255,255,0.4)" strokeWidth="3"/><circle cx="22" cy="22" r="8" fill="rgba(255,255,255,0.6)"/><circle cx="78" cy="22" r="8" fill="rgba(255,255,255,0.6)"/><circle cx="22" cy="78" r="8" fill="rgba(255,255,255,0.6)"/><circle cx="78" cy="78" r="8" fill="rgba(255,255,255,0.6)"/><text x="50" y="62" fontSize="38" fill="white" fontFamily="Arial" fontWeight="800" textAnchor="middle">G</text></svg></div>
          {children}
        </div>
      </div>
    </div>
  );
};

export const Btn = ({ children, primary, danger, small, full, onClick, disabled, style: sx }) => {
  const { c } = useApp();
  return (
    <button onClick={onClick} disabled={disabled} style={{ padding: small ? "6px 14px" : "11px 20px", borderRadius: small ? 8 : 11, border: primary || danger ? "none" : `1px solid ${c.border}`, background: disabled ? c.input : primary ? c.grad : danger ? c.redBg : c.card, color: disabled ? c.faint : primary ? "#fff" : danger ? c.redTxt : c.text, fontSize: small ? 12 : 14, fontWeight: 700, cursor: disabled ? "default" : "pointer", width: full ? "100%" : "auto", transition: "all 0.2s", ...sx }}>{children}</button>
  );
};

export const EmojiPicker = ({ onSelect, position = "below", emojiRef }) => {
  const { c } = useApp();
  return (
    <div ref={emojiRef} style={{ position: "absolute", [position === "above" ? "bottom" : "top"]: "calc(100% + 8px)", left: 0, width: 310, maxHeight: 270, background: c.card, borderRadius: 16, border: `1px solid ${c.border}`, boxShadow: c.shd, overflow: "auto", zIndex: 50, padding: "4px 0" }}>
      {Object.entries(EMOJI_CATS).map(([cat, emojis]) => (
        <div key={cat}>
          <div style={{ padding: "8px 12px 4px", fontSize: 11, fontWeight: 700, color: c.sub, letterSpacing: "0.04em" }}>{cat}</div>
          <div style={{ display: "flex", flexWrap: "wrap", padding: "0 6px 4px" }}>
            {emojis.map(em => (
              <button key={em} onClick={() => onSelect(em)} style={{ width: 33, height: 33, border: "none", background: "transparent", fontSize: 18, cursor: "pointer", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center" }}>{em}</button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export const TrustBar = ({ score, size = "normal" }) => {
  const { c } = useApp();
  const col = score >= 80 ? c.grn : score >= 50 ? c.gold : c.red;
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
        <span style={{ fontSize: size === "small" ? 11 : 12, fontWeight: 700, color: c.sub }}>Trust Score</span>
        <span style={{ fontSize: size === "small" ? 11 : 12, fontWeight: 800, color: col }}>★ {score}</span>
      </div>
      <div style={{ height: size === "small" ? 5 : 7, borderRadius: 4, background: c.border }}>
        <div style={{ height: "100%", borderRadius: 4, width: `${score}%`, background: col, transition: "width 0.5s" }} />
      </div>
    </div>
  );
};

export const Stat = ({ icon, label, value, color }) => {
  const { c } = useApp();
  return (
    <div style={{ background: c.card, borderRadius: 13, border: `1px solid ${c.border}`, padding: "14px 16px", display: "flex", alignItems: "center", gap: 12 }}>
      <div style={{ width: 42, height: 42, borderRadius: 11, background: `${color}12`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 19 }}>{icon}</div>
      <div><div style={{ fontSize: 18, fontWeight: 800, color: c.text }}>{value}</div><div style={{ fontSize: 11, color: c.sub, fontWeight: 600 }}>{label}</div></div>
    </div>
  );
};

export const Toggle = ({ on, onToggle }) => {
  const { c } = useApp();
  return (
    <div onClick={onToggle} style={{ width: 44, height: 24, borderRadius: 12, cursor: "pointer", background: on ? c.grn : c.border, position: "relative", transition: "background 0.2s", flexShrink: 0 }}>
      <div style={{ width: 20, height: 20, borderRadius: 10, background: "#fff", position: "absolute", top: 2, left: on ? 22 : 2, transition: "left 0.2s", boxShadow: "0 1px 4px rgba(0,0,0,0.2)" }} />
    </div>
  );
};

export const EmptyState = ({ icon, title, desc }) => {
  const { c } = useApp();
  return (
    <div style={{ textAlign: "center", padding: "50px 20px", color: c.faint }}>
      <div style={{ fontSize: 44, marginBottom: 10 }}>{icon}</div>
      <div style={{ fontSize: 16, fontWeight: 700, color: c.sub }}>{title}</div>
      {desc && <div style={{ fontSize: 13, marginTop: 4 }}>{desc}</div>}
    </div>
  );
};

export const LiveRedRoom = () => (
  <div style={{ position: "relative", width: 90, height: 90, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 }}>
    {[0, 0.6, 1.2].map((delay, i) => (
      <div key={i} style={{ position: "absolute", borderRadius: "50%", width: 70, height: 70, border: "2px solid rgba(255,0,0,0.4)", animation: `gcPulse 2s ${delay}s infinite` }} />
    ))}
    <div style={{ width: 56, height: 56, borderRadius: "50%", background: "radial-gradient(circle at 30% 30%, #ff5a5a, #ff0000)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 0 5px rgba(255,0,0,0.08), 0 0 25px rgba(255,0,0,0.6), 0 0 45px rgba(255,0,0,0.4)", animation: "gcHeartbeat 1.1s infinite" }}>
      <div style={{ width: 26, height: 26, borderRadius: "50%", background: "#ff0000", boxShadow: "inset 0 3px 8px rgba(255,255,255,.35), 0 0 12px rgba(255,0,0,0.9)" }} />
    </div>
    <div style={{ position: "absolute", top: -6, right: -10, background: "#ff0033", color: "white", fontSize: 10, fontWeight: 700, padding: "4px 7px", borderRadius: 999, letterSpacing: ".5px", boxShadow: "0 0 12px rgba(255,0,0,0.7)", animation: "gcBlink 1s infinite" }}>LIVE</div>
    <style>{`
      @keyframes gcPulse { 0% { transform: scale(.7); opacity: .8; } 100% { transform: scale(1.7); opacity: 0; } }
      @keyframes gcHeartbeat { 0% { transform: scale(1); } 14% { transform: scale(1.12); } 28% { transform: scale(1); } 42% { transform: scale(1.12); } 70% { transform: scale(1); } }
      @keyframes gcBlink { 0%, 50%, 100% { opacity: 1; } 25%, 75% { opacity: .35; } }
    `}</style>
  </div>
);